<template>
  <alert-card
    display="three-line-heading"
    :primaryHeading="upperHeading"
    :middleHeading="'12%'"
    lowerHeading="this month"
  >
  </alert-card>
</template>
<script>
import AlertCard from "../../../Components/UI/AlertCard.vue";
import { total } from "../../../Helpers/invoice.js";
export default {
  data() {
    return {};
  },
  computed: {
    events() {
      return this.$store.getters.events().sort((a, b) => {
        let startTime = (event) => {
          switch (event.api_version) {
            case "9-28-2022":
              return new Date(event.start_time).getTime();
            default:
              return new Date(event.data.startTime).getTime();
          }
        };
        let aStart = startTime(a);
        let bStart = startTime(b);
        return aStart < bStart ? -1 : aStart > bStart ? 1 : 0;
      });
    },
    priorMonthRevenue() {
      // todo : add payments array to account-level and add payments there also, and then use the payments array to calculate live revenue
      let priorMonth = new Date().getMonth() - 1;
      let events = this.getEventsByMonth(priorMonth);
      return this.getMonthTotal(events);
    },
    currentMonthRevenue() {
      let currentMonth = new Date().getMonth();
      let events = this.getEventsByMonth(currentMonth);
      return this.getMonthTotal(events);
    },
    upperHeading() {
      switch (Math.sign(this.currentMonthRevenue - this.priorMonthRevenue)) {
        case 1:
          return "Revenue is up";
        case -1:
          return "Revenue is down";
        default:
          return "Revenue is --";
      }
    },
    difference() {
      if (this.events.length > 0) {
        let difference = this.currentMonthRevenue - this.priorMonthRevenue;
        let percentage = (difference / this.priorMonthRevenue) * 100;
        return Math.floor(percentage) + "%";
      } else {
        return "--%";
      }
    },
  },
  methods: {
    getEventsByMonth(month) {
      return this.events.filter((x) => {
        let eventMonth = (x) => {
          switch (x.api_version) {
            case "9-28-2022":
              return new Date(x.date).getMonth();
            default:
              return new Date(x.data.date).getMonth();
          }
        };
        return eventMonth(x) === month;
      });
    },
    getMonthTotal(events) {
      let totals = events.map((x) => {
        return total(x);
      });
      return totals.reduce((a, b) => {
        return a + b;
      }, 0);
    },
  },
  created() {},
  components: {
    AlertCard,
  },
  props: [],
};
</script>
<style scoped></style>
